import React from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'ramda';
import { FormattedMessage } from 'react-intl';
import { StyledP, ContextItem, S3ErrorContext, StyledApolloErrorSectionCustom } from '../ErrorSection.styles';

const ApolloErrorSectionCustom = ({ error, children }) => (
  <StyledApolloErrorSectionCustom>
    <h1>
      <FormattedMessage id="errorBoundary.somethingWrong" />
    </h1>

    {error.graphQLErrors && (
      <>
        {uniqBy((e) => e.extensions.code, error.graphQLErrors).map(
          ({ message, extensions: { code, S3_CORRELATION_ID: s3CID, CORRELATION_ID: voyagerCID, context } }) => {
            const hasContext = Boolean(context);

            return (
              <div key={code}>
                <StyledP>
                  <FormattedMessage id="errorBoundary.errorCode" /> {code}
                </StyledP>

                <StyledP>
                  <FormattedMessage id="errorBoundary.errorMessage" /> {message}
                </StyledP>

                {voyagerCID && (
                  <StyledP>
                    <FormattedMessage id="errorBoundary.voyagerCorrelation" /> {voyagerCID}
                  </StyledP>
                )}

                {s3CID && (
                  <StyledP>
                    <FormattedMessage id="errorBoundary.s3Correlation" /> {s3CID}
                  </StyledP>
                )}

                {hasContext && (
                  <S3ErrorContext>
                    {Object.keys(context).map((c) => (
                      <li key={c}>
                        <ContextItem>{c}: </ContextItem>
                        {context[c]}
                      </li>
                    ))}
                  </S3ErrorContext>
                )}
              </div>
            );
          }
        )}
      </>
    )}

    {children}
  </StyledApolloErrorSectionCustom>
);

ApolloErrorSectionCustom.propTypes = {
  children: PropTypes.node,
  error: PropTypes.shape({
    actionCode: PropTypes.string,
    graphQLErrors: PropTypes.arrayOf(
      PropTypes.shape({
        message: PropTypes.string.isRequired,
        extensions: PropTypes.shape({
          code: PropTypes.string.isRequired
        }).isRequired
      })
    ).isRequired
  }).isRequired
};

export default ApolloErrorSectionCustom;
